module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#negative","viewBox":"0 0 48 48"}